import { cn } from "helpers/classNames";
import { NotesIcon } from "./icons/NotesIcon";

type Props = {
  className?: string;
  iconClassName?: string;
  textClassName?: string;
  text: string;
};

export const Notes = ({
  text,
  className,
  iconClassName,
  textClassName,
}: Props) => (
  <div className={cn("flex text-sm text-gray-500", className)}>
    <NotesIcon className={cn("mr-1", iconClassName)} />
    <span className={cn("", textClassName)}>{text}</span>
  </div>
);
